import React from "react";

const Hero = () => <div className="hero">Where Elegance Meets Tranquility</div>;

export default Hero;
